const key = 'AIzaSyC5UwM7iln-x8KqqpqOAxar9VtTOgqW1L4';

export default key;
